import { MERCHANT_PRODUCTS } from 'OpsCenter/app.constants';

export default function generalSettingsService($q, settingsService, areasService, GeneralSetting) {
  return {
    getSettings,
    updateSettings,
    getComposedSettings,
    runForFoundSetting,
  };

  function getSettings(merchantId, requestedAttributeSettingIds) {
    return settingsService.getSettings(merchantId, requestedAttributeSettingIds).then(response => {
      const settingsFromApi = response.data.settings;
      const attributeIdsOnApiResponse = settingsFromApi.map(s => s.settingAttributeId);

      if (hasMissingSettings()) {
        fillArrayWithDefaultObjectsForMissingSettings();
      }

      return settingsFromApi.map(GeneralSetting.build).sort((a, b) => a.settingAttributeId - b.settingAttributeId);

      function hasMissingSettings() {
        const includedInApiResponse = id => attributeIdsOnApiResponse.includes(id);
        return !requestedAttributeSettingIds.every(includedInApiResponse);
      }

      function fillArrayWithDefaultObjectsForMissingSettings() {
        const missingSettingIds = requestedAttributeSettingIds.filter(id => !attributeIdsOnApiResponse.includes(id));
        missingSettingIds.forEach(id => {
          const defaultValue = GeneralSetting.DEFAULT_SETTING_VALUES[id.toString()];
          if (defaultValue && defaultValue.settingAttributeId) {
            settingsFromApi.push(defaultValue);
          }
        });
      }
    });
  }

  function updateSettings(merchantId, settings) {
    return settingsService.updateSettings(merchantId, settings);
  }

  function getComposedSettings(merchantId, allSettingIds, merchant) {
    return $q
      .all([getSettings(merchantId, allSettingIds), areasService.getAreas(merchantId)])
      .then(composeSettings)
      .then(settings => decorateSettingsForView(settings, merchant));
  }

  function composeSettings(data) {
    const settings = data[0],
      areas = data[1].data.areas,
      overbookingSettings = GeneralSetting.getByCode(GeneralSetting.CODES.OVERBOOKING, settings);

    let selectedOverbookingAreaSettings, areaSettings;

    if (!areas.length || !overbookingSettings.length) {
      return settings;
    }

    selectedOverbookingAreaSettings = GeneralSetting.spliceByCode(GeneralSetting.CODES.OVERBOOKING_AREA, settings);

    areaSettings = composeOverbookingAreaSettings(areas, overbookingSettings[0], selectedOverbookingAreaSettings);

    return settings.concat(areaSettings);
  }

  function composeOverbookingAreaSettings(areas, overbookingSetting, selectedOverbookingAreaSettings) {
    const overbookingAreaSortOrder = overbookingSetting.sortOrder + 1;

    return areas.map(function(area) {
      let i = selectedOverbookingAreaSettings.length,
        composedOverbookingAreaSetting;

      for (; i--; ) {
        if (parseInt(selectedOverbookingAreaSettings[i].value, 10) === area.id) {
          composedOverbookingAreaSetting = GeneralSetting.build(selectedOverbookingAreaSettings.splice(i, 1)[0]);
          composedOverbookingAreaSetting.id = area.id;
          break;
        }
      }

      if (angular.isUndefined(composedOverbookingAreaSetting)) {
        // area has not been selected
        composedOverbookingAreaSetting = GeneralSetting.build({
          id: area.id,
          code: GeneralSetting.CODES.OVERBOOKING_AREA,
          unit: GeneralSetting.UNITS.N_A,
          settingAttributeId: GeneralSetting.SETTING_ATTRIBUTE_IDS.OVERBOOKING_AREA,
          sortOrder: overbookingAreaSortOrder,
          name: GeneralSetting.NAMES.OVERBOOKING_AREA,
          value: 0,
          minValue: 0,
          oldValue: area.id,
        });
      }

      composedOverbookingAreaSetting.parent = overbookingSetting;
      composedOverbookingAreaSetting.title = area.name;

      return composedOverbookingAreaSetting;
    });
  }

  function decorateSettingsForView(settings, merchant) {
    return settings.map(setting => formatSetting(setting, merchant));
  }

  function formatSetting(setting, merchant) {
    if (/^true$/i.test(setting.value)) {
      setting.value = 1;
    } else if (/^false$/i.test(setting.value)) {
      setting.value = 0;
    }

    if (
      setting.code !== GeneralSetting.CODES.DEFAULT_VIEW &&
      setting.code !== GeneralSetting.CODES.AVERAGE_SPENT_PER_PERSON &&
      setting.code !== GeneralSetting.CODES.AIRREGI_INTEGRATION_TOKEN &&
      setting.code !== GeneralSetting.CODES.SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL_MESSAGE
    ) {
      // awesome exception handling
      setting.value = parseInt(setting.value, 10);
    }

    if (setting.code && GeneralSetting.possibleValuesMappings.hasOwnProperty(setting.code)) {
      setting.possibleValues = (setting.code === GeneralSetting.CODES.ONLINE_RESERVATION_INTERVAL &&
        merchant.productIds.includes(MERCHANT_PRODUCTS.EXTERNAL_PARTNER))
        ? GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.ONLINE_RESERVATION_INTERVAL_EXTERNAL_PARTNER]
        : GeneralSetting.possibleValuesMappings[setting.code];
    }

    return setting;
  }

  function runForFoundSetting(settings, settingCode, cb) {
    const foundSetting = settings.find(function(setting) {
      return setting.code === settingCode;
    });

    if (foundSetting) {
      cb(foundSetting);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/settings/generalSettings.service.js